<template>
  <el-card :body-style="{ padding: '0px', height: '100%' }">
    <div
      class="banner"
      id="banner"
      :style="{ width: isCollapse ? '60px' : '240px' }"
    >
      <div class="top">
        <!-- <el-avatar :size="!isCollapse? 90 : 60" :src="circleUrl" shape="circle">
        </el-avatar> -->
        <div class="menu-but">
          <i @click="funRefold()" class="icon_refold" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
        <div v-if="!isCollapse" style="width: 90px;height: 90px;">
          <img :src="circleUrl !== 'data:image/png;base64,null' ? circleUrl : require('@/static/home/tx.png')" alt="" style="width: 100%;height: 100%;border-radius: 50%; background-color: #eceff7;">
        </div>
        <span v-if="!isCollapse" style="margin:0px;font-family: 黑体;color: #136de4;font-size: 16px;">{{ username }}，欢迎您登录</span>
      </div>
      <div class="site-sidebar__inner" id="banner_menu" >
        <!--
			url:　https://element.eleme.io/#/zh-CN/component/menu
			default-active:	当前激活菜单的 index
			collapse:	是否水平折叠收起菜单（仅在 mode 为 vertical 时可用）
			background-color:	菜单的背景色（仅支持 hex 格式）
			text-color:	菜单的文字颜色（仅支持 hex 格式）
			unique-opened:	是否只保持一个子菜单的展开
			active-text-color:	当前激活菜单的文字颜色（仅支持 hex 格式）
			collapse-transition:	是否开启折叠动画
			-->

        <el-menu
          @open="handleOpen"
          :style="{ width: isCollapse ? '60px' : '240px' }"
          unique-opened
          style="margin-bottom: 100px"
          @close="handleClose"
          :default-active="this.$route.path"
          router
          :collapse="isCollapse"
          collapse-transition
        >
          <menuItem :menus="menus"></menuItem>
        </el-menu>
      </div>
    </div>
  </el-card>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

import menuItem from "./menuItem.vue";

@Component({
  name: "Banner",
  components: {
    menuItem: menuItem,
  },
})
export default class Banner extends Vue {
  name = "";
  checkIndex = "";
  circleUrl = "";
  created() {
    this.getHeadImage();
  }
  /*
		{
			path: '路由路径',
			icon: '图标class',
			title: '菜单名称',
			children: [子菜单对象]
		}
		*/
  getHeadImage() {
    this.$request({
      url: "/bjba/yhgl/getHeadImageByUserName",
      method: "get",
      params: {
        username: this.$store.getters.user.username,
      },
    })
      .then((response) => {
        console.log(response);
        let data = response.data;

        this.circleUrl = "data:image/png;base64," + data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  menus = JSON.parse(sessionStorage.getItem("menuList") || "[]");

  //菜单展开折叠
  funRefold() {
    let refold = this.$store.getters.isUnfold
    this.$store.commit('updateUnfold', !refold)
  }

  handleOpen(key, keyPath) {
    console.log(key, keyPath);
  }
  handleClose(key, keyPath) {
    console.log(key, keyPath);
  }
  get isCollapse() {
    return this.$store.getters.isUnfold;
  }
  get username() {
    return this.$store.getters.user.name;
  }
}
</script>

<style lang="scss" scoped>
html {
  margin: 10;
  padding: 0;
}
.el-menu--collapse {
  width: 85px;
}
.el-aside {
  //overflow: unset;
  overflow:scroll;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.el-menu {
  border: none !important;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: #ffffff;
}

.banner {
  // background-color: #5764ff;
  background-color: #ffffff;
  justify-content: start;
  align-items: start;
  height: 100%;
  overflow: hidden;
}

::v-deep span {
  font-size: 14px;
}

.top {
  margin-top: 10px;
  height: 6rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
}

.top_img {
  height: 3rem;
  width: 3rem;
  background-image: url("../../../../../assets/bjba/sy/Oval.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.menu-but {
  width: 30px; 
  height: 30px; 
  position: absolute; 
  top: 30px; 
  left: 0;
}

.icon_refold {
  font-size: 30px;
  cursor: pointer;
}
::v-deep #banner_menu .el-menu .el-submenu .el-submenu__title {
  height: 45px;
  line-height: 45px;
}
::v-deep #banner_menu {
  width: 240px;
  overflow-y: hidden;
}

::v-deep .el-submenu__title .el-icon-arrow-down {
  //change the icon position
  &:before {
    content: "\e790";//change icon type
    font-size: 18px;
    color: #000000;
  }
}

/*close menu*/
::v-deep .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotate(-90deg) !important;
}
/*open menu*/
::v-deep .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotate(0deg) !important;
}

::v-deep .icon-menu {
  color: #909399;
  font-size: 20px !important;
  margin: 0rem 0.5rem !important;
}
::v-deep .el-submenu__icon-arrow,
.el-icon-arrow-down {
  color: #909399;
  font-size: 16px !important;
}
::v-deep li {
  text-align: left;
}
</style>




